import { GET_MEMBERSHIP_QUOTA, GET_MEMBERSHIP_QUOTA_SUCCESS, GET_MEMBERSHIP_QUOTA_ERROR, GET_MEMBERSHIP_QUOTA_EMPTY } from '../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetMembershipQuota = (state = initialState, action) => {
  switch (action.type) {
    case GET_MEMBERSHIP_QUOTA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_MEMBERSHIP_QUOTA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_MEMBERSHIP_QUOTA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_MEMBERSHIP_QUOTA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetMembershipQuota;
